import React from "react";

export default function ConvoBreak() {
  return <hr className="my-6 border-t border-gray-300" />;
}

// ConvoBreak doesn't have an editor since it has no options
ConvoBreak.Editor = null;
